import { Keyframe, WeightedMode } from "./Keyframe";
import { Vector4 } from "./Vector4";
export class Vector4Keyframe extends Keyframe {
    constructor(weightMode = false) {
        super();
        this.inTangent = new Vector4();
        this.outTangent = new Vector4();
        this.value = new Vector4();
        if (weightMode) {
            this.inWeight = new Vector4(Keyframe.defaultWeight, Keyframe.defaultWeight, Keyframe.defaultWeight, Keyframe.defaultWeight);
            this.outWeight = new Vector4(Keyframe.defaultWeight, Keyframe.defaultWeight, Keyframe.defaultWeight, Keyframe.defaultWeight);
            this.weightedMode = new Vector4(WeightedMode.None, WeightedMode.None, WeightedMode.None, WeightedMode.None);
        }
    }
    cloneTo(dest) {
        super.cloneTo(dest);
        this.inTangent.cloneTo(dest.inTangent);
        this.outTangent.cloneTo(dest.outTangent);
        this.value.cloneTo(dest.value);
        if (this.weightedMode) {
            this.inWeight.cloneTo(dest.inWeight);
            this.outWeight.cloneTo(dest.outWeight);
            this.weightedMode.cloneTo(dest.weightedMode);
        }
    }
}
